import { SVGProps, Ref, forwardRef } from 'react';

export const CircleFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M12 1c8.25 0 11 5.5 11 11s-2.75 11-11 11S1 17.5 1 12 3.75 1 12 1" fill="currentColor" />
        </g>
    </svg>
));
CircleFilledSize24Glyph.displayName = 'CircleFilledSize24Glyph';
